<!--
 * @LastEditors: chuhongguang
 * @desc: 制表记录的图（Echarts)
 * @场景: 重构公式 抽屉中
-->
<template>
  <div class="align_left">
    <el-checkbox @change="averageChange()" v-model="average">按列平均</el-checkbox>
    <el-button class="m_l_10" @click="allSelect()" size="mini">全选</el-button>
    <div :id="this.matrixData._id" :style="{height: '400px', width: '100%'}" v-loading="loading"></div>
  </div>
</template>
<script>
import { updateOptionSeries, updateOptionLegend, removeOptionSeries, removeOptionLegend } from '@/api/updateGraphOption.js'
import { getRequest } from '@/api/dailyBackTest.js'
export default {
  props: ['matrixData', 'activeName'],
  data () {
    return {
      loading: false,
      myChart: null,
      option: {},
      xAxisData: [],
      legendData: [],
      average: false,
      tablesData: [],
      is_all: false
    }
  },
  mounted () {
    this.getMatrixByCoordinate()
  },
  methods: {
    allSelect () {
      let selected = {}
      for (let i = 0; i < this.legendData.length; i++) {
        selected[this.legendData[i]] = this.is_all
      }
      selected['按列平均'] = true
      this.option.legend['selected'] = selected
      this.myChart.setOption(this.option)
      this.is_all = !this.is_all
    },
    averageChange () {
      if (this.average) {
        var averageData = []
        for (let j = 0; j < this.xAxisData.length; j++) {
          let data = 0
          let num = 0
          for (let i = 0; i < this.legendData.length; i++) {
            if (this.tablesData[j][i] !== null) {
              data = data + this.tablesData[j][i]
              num = num + 1
            }
          }
          let ave = null
          if (num) {
            ave = Math.round(1e2 * (data / num)) / 1e2
          }
          averageData.push(ave)
        }
        var querys = '按列平均'
        var contents = {
          name: querys,
          data: averageData,
          type: 'line',
          connectNulls: true,
          lineStyle: {
            color: '#000',
            width: 2 // 设置线条粗细
          },
          itemStyle: {
            color: '#000'
          }
        }
        updateOptionLegend(this.option, querys)
        updateOptionSeries(this.option, querys, contents)
        this.myChart.setOption(this.option, true)
      } else {
        removeOptionSeries(this.option, '按列平均')
        removeOptionLegend(this.option, '按列平均')
        this.myChart.setOption(this.option, true)
      }
    },
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      if (this.myChart === null) {
        this.myChart = this.$echarts.init(document.getElementById(this.matrixData._id))
      }
      // 绘制图表
      this.option = {
        legend: {
          data: this.legendData,
          type: 'scroll',
          width: '90%',
          backgroundColor: 'transparent'
          // left: '10%'
        },
        toolbox: {
        },
        tooltip: {
          // trigger: 'axis',
          // triggerOn: 'click',
          // confine: true,
          // enterable: true
          formatter: (param) => {
            // console.log(param)
            let text = '<span style="user-select: text;">' + param.name + '</span><br/>'
            let value = param.value
            if (value === null && value === undefined) {
              value = '-'
            }
            text = text + '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:' + param.color + '"></span><span style="user-select: text;">' + param.seriesName + '：' + value + '</span><br/>'
            return text
          },
          extraCssText: 'max-width: 450px; white-space: normal; word-break: break-all;'
        },
        dataZoom: [
          {
            type: 'inside',
            startValue: this.xAxisData[0],
            endValue: this.xAxisData[this.xAxisData.length - 1]
          },
          {
            show: true,
            type: 'slider',
            fillerColor: 'rgba(167, 183, 204, 0.4)',
            // handleStyle: {
            //   color: '#a7b7cc',
            //   borderColor: '#000'
            // },
            top: '90%'
          }
        ],
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          // 网格样式
          splitLine: {
            show: true
          },
          boundaryGap: false
        },
        yAxis: {
          boundaryGap: ['0%', '10%'],
          type: 'value',
          min: 'dataMin',
          max: 'dataMax'
        },
        grid: {
          show: true,
          z: 0,
          top: 70,
          right: 80
        },
        series: [
        ]
      }
      var _this = this
      this.loading = false
      this.myChart.setOption(this.option)
      window.addEventListener('resize', function () {
        if (_this.myChart) {
          _this.myChart.resize()
        }
      })
    },
    clearData () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.myChart = this.$echarts.init(document.getElementById(this.matrixData._id))
      this.myChart.clear()
    },
    getMatrixByCoordinate () { // table函数数据
      console.log(this.matrixData)
      if (!this.matrixData._id) {
        return
      }
      this.loading = true
      var _this = this
      getRequest('/dataSupport/getMatrixByCoordinate', {id: this.matrixData._id, x: 0, w: this.matrixData.row_len, y: 0, h: this.matrixData.column_len}).then(function (x) {
        _this.loading = false
        if (x.data.data && !x.data.message) {
          _this.tablesData = x.data.data
          // console.log(_this.tablesData)
          _this.init()
        }
      })
    },
    init () {
      let column = this.matrixData.column
      this.xAxisData = this.matrixData.row
      let length = column.length
      if (length > 50) {
        length = 50
      }
      // console.log(column)
      this.legendData = []
      for (let i = 0; i < length; i++) {
        if (typeof column[i] !== 'string') {
          this.legendData.push(column[i].toString())
        } else {
          this.legendData.push(column[i])
        }
      }
      // console.log(this.legendData)
      let series = []
      for (let i = 0; i < this.legendData.length; i++) {
        let data = []
        for (let j = 0; j < this.xAxisData.length; j++) {
          data.push(this.tablesData[j][i])
        }
        series.push({
          name: this.legendData[i],
          type: 'line',
          connectNulls: true,
          lineStyle: {
            width: 2 // 设置线条粗细
          },
          // emphasis: emphasisStyle,
          data: data
        })
      }
      this.drawLine()
      console.log(series)
      this.option['series'] = series
      // console.log(this.option)
      this.myChart.setOption(this.option, true)
      this.averageChange()
    }
  },
  watch: {
    // 监听父组件传入的数据，更新到本地
    matrixData (newVal, oldVal) {
      this.getMatrixByCoordinate()
    },
    activeName () {
      if (this.myChart) {
        this.myChart.resize()
      }
    }
  }
}
</script>
<style scoped>
  .el-collapse-item {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__header {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__wrap {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  h4 {
    margin-bottom:0px;
  }
  .bannerTextRed{
    padding: 0 4px;
    line-height: 18px;
    height: 18px;
    border-radius: 4px;
    font-weight: 400;
    background-color:indianred;
    color:white;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/allPage/tableLine.vue